import Joi from 'joi';
import { actionCreator, objectSchemaOf } from '../helpers';
import type { IShowOptionsPayload } from './showOptionsAction';
import { showOptionsPayloadSchema } from './showOptionsAction';
import { USER_INPUT_INPUT } from './topics';

export const OPTIONS_DISPLAYED = 'USER_INPUT/OPTIONS_DISPLAYED';

export interface IOptionsDisplayedAction {
  type: typeof OPTIONS_DISPLAYED;
  payload: IShowOptionsPayload;
}

export const optionsDisplayedActionSchema = objectSchemaOf<IOptionsDisplayedAction>(
  {
    type: Joi.string().required().valid(OPTIONS_DISPLAYED),
    payload: showOptionsPayloadSchema.required(),
  }
);

export const optionsDisplayed = actionCreator({
  type: OPTIONS_DISPLAYED,
  schema: optionsDisplayedActionSchema,
  topic: USER_INPUT_INPUT,
});
